import { LocationProviderQueryKeys } from '~/components/providers/query';
import { reportEvent } from '~/domains/analytics';
import { PermissionStatusState } from '~/utils/geoPermissions';

import { over18UnderLegalAgeStates, specialStates } from '../consts';
import type { AccessChecksProps, ProtectionGuardType } from '../types';

function locationCheck({
  action,
  contestId,
  geoPermissionStatus,
  isGeoComplyEnabled,
  isLocationLoading,
  locationErrors,
  locationState,
  locationStatus,
  userId,
  userAge,
  closeModalsByType,
  forceRerender,
  handleOnAccessFailed,
  openModalUnique,
}: AccessChecksProps<ProtectionGuardType.LOCATION>) {
  if (isLocationLoading) return;

  const locationTokenQueryKey = LocationProviderQueryKeys.LOCATION_TOKEN(
    userId,
    geoPermissionStatus
  );

  // Analytics reporting
  const reportFailedEvent = () => {
    reportEvent('ProtectionGuard > Location Check Failed', {
      action,
      contestId,
      geoPermissionStatus,
      locationErrors,
      locationState,
      locationStatus,
      userId,
      userAge,
    });
  };

  if (!isGeoComplyEnabled) {
    closeModalsByType('LocationPermissionRequiredModal');
  }

  // No location permission
  if (isGeoComplyEnabled && geoPermissionStatus !== PermissionStatusState.GRANTED) {
    openModalUnique({
      type: 'LocationPermissionRequiredModal',
      onRecheckPermission: () => {
        closeModalsByType('LocationPermissionRequiredModal');
        forceRerender();
      },
    }).then(handleOnAccessFailed);

    reportFailedEvent();
    return false;
  }
  if (geoPermissionStatus === PermissionStatusState.GRANTED) {
    closeModalsByType('LocationPermissionRequiredModal');
  }

  // User is under legal age specific to the state
  if (locationState && specialStates.includes(locationState)) {
    const { age: requiredAge } = over18UnderLegalAgeStates[locationState];

    if (userAge < requiredAge) {
      openModalUnique({
        type: 'AgeRestrictionModal',
        queryKey: locationTokenQueryKey,
      }).then(handleOnAccessFailed);

      reportFailedEvent();
      return false;
    }

    if (userAge >= requiredAge) {
      closeModalsByType('AgeRestrictionModal');
    }
  }

  return true;
}

export { locationCheck };
